import { isWithinInterval } from 'date-fns';
import { Week, WeekNrCell, DayCell, Day } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var isInSelectedInterval = function isInSelectedInterval(dateStr, selectedDateInterval, selectedMonths) {
  if (!(selectedDateInterval.from || selectedDateInterval.to) && !selectedMonths.length) {
    return false;
  }
  var date = new Date(dateStr);
  if (selectedMonths.length) {
    var y = date.getUTCFullYear();
    var m = date.getMonth();
    return !!selectedMonths.find(function (month) {
      var d = new Date(month);
      return d.getUTCFullYear() === y && d.getMonth() === m;
    }); // YYYY-MM
  }

  try {
    return isWithinInterval(date, {
      start: new Date(selectedDateInterval.from),
      end: new Date(selectedDateInterval.to)
    });
  } catch (e) {
    return false;
  }
};
var MonthRow = function MonthRow(_ref) {
  var weekNumber = _ref.weekNumber,
    weekDays = _ref.weekDays,
    selectedDay = _ref.selectedDay,
    onSelectDay = _ref.onSelectDay,
    selectedDateInterval = _ref.selectedDateInterval,
    selectedMonths = _ref.selectedMonths;
  if (weekDays.length !== 7) {
    throw new TypeError('WeekDays must be 7 days long');
  }
  return /*#__PURE__*/jsxs(Week, {
    children: [/*#__PURE__*/jsx(WeekNrCell, {
      children: weekNumber
    }), weekDays.map(function (day, i) {
      if (!day) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          jsx(DayCell, {
            children: /*#__PURE__*/jsx(Day, {
              type: "button",
              disabled: true
            })
          }, "empty-".concat(i))
        );
      }
      var dateIsSelected = selectedDay && selectedDay === day.fullDate;
      var isDateInRange = isInSelectedInterval(day.fullDate, selectedDateInterval, selectedMonths);
      return /*#__PURE__*/jsx(DayCell, {
        inRange: isDateInRange,
        children: /*#__PURE__*/jsx(Day, {
          disabled: day.disabled,
          selected: dateIsSelected,
          type: "button",
          onClick: function onClick() {
            return !day.disabled && onSelectDay(day.fullDate);
          },
          children: day.date
        })
      }, day.date);
    })]
  });
};
MonthRow.defaultProps = {
  weekNumber: '1',
  weekDays: [],
  selectedDay: '',
  selectedDateInterval: {},
  selectedMonths: []
};
var MonthRow$1 = MonthRow;

export { MonthRow$1 as default };
//# sourceMappingURL=MonthRow.js.map
